/**
 * Scroll Services
 *
 * @format
 */

import inViewport from 'javascript-inviewport';
import { setProgress } from './animated-link';

/**
 * Load Scroll Services.
 */
export const loadScrollServices = (): void => {
  /**
   * Animate Circle Check.
   */
  const animateCircleCheck = (element: Element): void => {
    if (element.classList.contains('circle-loading')) {
      element.classList.remove('circle-loading');
      setTimeout(() => {
        setProgress(100, 'circle-ring');
      }, 2000);
    }
  };

  /**
   * Scroll Into View Load.
   */
  const scrollIntoViewLoad = (): void => {
    const loadingElements: NodeListOf<Element> =
      document.querySelectorAll('.loading');
    if (loadingElements.length > 0) {
      Array.prototype.forEach.call(loadingElements, (element) => {
        inViewport(element, 0.05, () => {
          element.classList.remove('loading');
          animateCircleCheck(element);
        });
      });
    }
  };
  scrollIntoViewLoad();
  setProgress(0, 'circle-ring');
};
